import React, { useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import FormDialog from './../Dialogs/FormDialog';
import { useShopAPI } from './../../API/Shop';
import { useSelector } from 'react-redux';
import './CounterGood.css';

const CounterGood = ({ card, count, basketID, good, size, dialog, cloneid, onAdd }) => {
        const { CounterGoodAction, AddItemBasketAction, buyDigitGood } = useShopAPI();
        const { t } = useTranslation();
        const [loading, setLoading] = React.useState(false);
        const [openDialogCount, setOpenDialogCount] = React.useState(false);
        const [countState, setCountState] = React.useState('');
        const minusButtonRef = useRef(null);
        const plusButtonRef = useRef(null);
        const addButtonRef = useRef(null);
        const totalCountGoodsRef = useRef(null);
        const SettingsSession = useSelector(state => state.shop.shop.settings);

        const handleClickOpenCountDialog = () => {
            setOpenDialogCount(true);
        };

        const handleBuyDigitProduct = async(goodID) => {
            const response = await buyDigitGood(goodID);
            if(response.invoice_link !== undefined) {
                await window.Telegram.WebApp.openInvoice(response.invoice_link);
                window.Telegram.WebApp.onEvent('invoiceClosed', (event) => {
                    if (event.status === 'paid') {
                        window.Telegram.WebApp.showAlert('Успешный платеж!');
                        window.location.href = "https://t.me/"+SettingsSession.bot_username;
                        window.Telegram.WebApp.close();
                    } else if (event.status === 'failed') {
                        window.Telegram.WebApp.HapticFeedback.notificationOccurred('error');
                    } else {
                        window.Telegram.WebApp.HapticFeedback.notificationOccurred('warning');
                    }
                });
            } else {
                window.Telegram.WebApp.showAlert(response.message);
            }
        }

        const handleCloseCountDialog = () => {
            setOpenDialogCount(false);
        };

        const handleChangeCountItem = () => {
            CounterGoodAction('set', basketID, setLoading, countState, cloneid);
            handleCloseCountDialog();
        }

        const handleBounceAnimation = (ref) => {
            // if (ref.current) {
            //     ref.current.classList.add('bounce');
            //     setTimeout(() => {
            //         if (ref.current) {
            //             ref.current.classList.remove('bounce');
            //         }
            //     }, 200);
            // }

            if (totalCountGoodsRef.current) {
                totalCountGoodsRef.current.classList.add('bounce');
                setTimeout(() => {
                    if (totalCountGoodsRef.current) {
                        totalCountGoodsRef.current.classList.remove('bounce');
                    }
                }, 200);
            }
        };

        const handleBasketCountChange = (nextCount, buttonRef) => {
            const normalizedCount = Math.floor(Number(nextCount) || 0);
            const action = normalizedCount < 1 ? 'delete' : 'set';
            const setCount = normalizedCount < 1 ? false : normalizedCount;

            CounterGoodAction(action, basketID, setLoading, setCount, cloneid);
            handleBounceAnimation(buttonRef);
        };

        const miniButtonStyle = { padding: 8, minWidth: 0, lineHeight: 0, aspectRatio: "1/1" };

        const styleCounterTop = SettingsSession.col < 6 ? {
            width: 23,
            height: 23,
            fontSize: 10,
            left: "80%"
        } : {};

        const isCardAdd = card === 'card-add';

        return (
            <>
                {
                    card === 'basket' ? (
                        <>
                            <Button ref={minusButtonRef} className="btn mainButton btn-sm animated-button"
                                    onClick={() => {
                                        handleBasketCountChange(Number(count) - 1, minusButtonRef);
                                    }}
                                    style={miniButtonStyle}>
                                <i className="bi bi-dash"></i>
                            </Button>
                            <b className="pr-2 pl-2">
                                {loading ? (
                                    <p className="pr-2 pl-2" onClick={() => handleClickOpenCountDialog()}>{count}</p>
                                ) : (
                                    <p className="pr-2 pl-2" onClick={() => handleClickOpenCountDialog()}>{count}</p>
                                )}
                            </b>
                            <Button ref={plusButtonRef} className="btn mainButton btn-sm animated-button"
                                    onClick={() => {
                                        handleBasketCountChange(Number(count) + 1, plusButtonRef);
                                    }} style={miniButtonStyle}>
                                <i className="bi bi-plus"></i>
                            </Button>
                            <FormDialog
                                open={openDialogCount}
                                setOpen={setOpenDialogCount}
                                handleClickOpen={handleClickOpenCountDialog}
                                handleClose={handleCloseCountDialog}
                                textDialog={t('writeQuantityOfGoods')}
                                labelDialog={t('quantityGoods')}
                                inputState={countState}
                                setInputState={setCountState}
                                onSubmit={handleChangeCountItem} />
                        </>
                    ) : (
                        <>
                            {
                                good !== undefined && good.isDigit !== undefined && good.isDigit === true && SettingsSession.isDigitShop === false ? (
                                    <Button ref={addButtonRef} className="mainButton btn w-100 animated-button"
                                            onClick={() => {
                                                handleBuyDigitProduct(good.id)
                                            }}
                                            style={{height: 36.5}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 26 24" fill="none">
                                            <path fill="#fff" fillRule="evenodd"
                                                  d="M9.522 14.866a1 1 0 0 0 1.1.653l12.766-2.036a1 1 0 0 0 .823-.792l1.355-6.792a1 1 0 0 0-.964-1.196l-17.36-.28a1 1 0 0 0-.958 1.335l3.238 9.108ZM10.326 23.052a2.326 2.326 0 1 0 0-4.652 2.326 2.326 0 0 0 0 4.652ZM21.957 23.052a2.326 2.326 0 1 0 0-4.652 2.326 2.326 0 0 0 0 4.652Z"
                                                  clipRule="evenodd"/>
                                            <path fill="#fff"
                                                  d="M6.169.9h-4.71a1.31 1.31 0 1 0 0 2.618h3.337a1 1 0 0 1 .945.672l.942 2.71L9.35 5.6 8.035 2.182A2 2 0 0 0 6.17.9Z"/>
                                        </svg>
                                        <small className={"ml-1"}>{t('buy')}</small>
                                    </Button>
                                ) : (
                                    <>
                                        <div className="d-flex" style={{height: 36.5}}>

                                            <div className="addButtonsContainer" style={{ height: 36.5 }}>
                                                <Button
                                                    ref={minusButtonRef}
                                                    className={`animated-button mainButton btn-sm btn ${
                                                        isCardAdd ? 'minus-hidden' : 'minus-visible'
                                                    }`}
                                                    onClick={() => {
                                                        CounterGoodAction('minus', basketID, setLoading, false, cloneid);
                                                        handleBounceAnimation(minusButtonRef);
                                                    }}
                                                    sx={{ height: 36.5 }}
                                                >
                                                    <i className="bi bi-dash"></i>
                                                </Button>

                                                {
                                                    good !== null && !isCardAdd && dialog ? (
                                                        <Button
                                                            className="mainButton btn d-flex br-12 align-items-center p-2 pl-3 pr-3 ml-2 mr-2"
                                                            onClick={() => {
                                                                handleClickOpenCountDialog();
                                                            }}
                                                            sx={{ height: 36.5 }}
                                                        >
                                                            {count}
                                                        </Button>
                                                    ) : null
                                                }

                                                {
                                                    good !== null && !isCardAdd && !dialog ? (
                                                        <span className="p-1"></span>
                                                    ) : null
                                                }

                                                <Button
                                                    ref={isCardAdd ? addButtonRef : plusButtonRef}
                                                    className={`animated-button mainButton btn-sm btn ${
                                                        isCardAdd ? 'add-full' : 'add-half'
                                                    }`}
                                                    sx={{ height: 36.5 }}
                                                    onClick={() => {
                                                        if (isCardAdd) {
                                                            AddItemBasketAction(good, size, setLoading);
                                                            handleBounceAnimation(addButtonRef);
                                                            if (onAdd) {
                                                                onAdd();
                                                            }
                                                        } else {
                                                            CounterGoodAction('plus', basketID, setLoading, false, cloneid);
                                                            handleBounceAnimation(plusButtonRef);
                                                        }
                                                    }}
                                                >
                                                    {isCardAdd ? (
                                                        <>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 26 24" fill="none">
                                                                <path
                                                                    fill="#fff"
                                                                    fillRule="evenodd"
                                                                    d="M9.522 14.866a1 1 0 0 0 1.1.653l12.766-2.036a1 1 0 0 0 .823-.792l1.355-6.792a1 1 0 0 0-.964-1.196l-17.36-.28a1 1 0 0 0-.958 1.335l3.238 9.108ZM10.326 23.052a2.326 2.326 0 1 0 0-4.652 2.326 2.326 0 0 0 0 4.652ZM21.957 23.052a2.326 2.326 0 1 0 0-4.652 2.326 2.326 0 0 0 0 4.652Z"
                                                                    clipRule="evenodd"
                                                                />
                                                                <path
                                                                    fill="#fff"
                                                                    d="M6.169.9h-4.71a1.31 1.31 0 1 0 0 2.618h3.337a1 1 0 0 1 .945.672l.942 2.71L9.35 5.6 8.035 2.182A2 2 0 0 0 6.17.9Z"
                                                                />
                                                            </svg>
                                                            <small className="ml-1">{t('addToBasket')}</small>
                                                        </>
                                                    ) : (
                                                        <i className="bi bi-plus"></i>
                                                    )}
                                                </Button>
                                            </div>
                                            {
                                                (good !== null && card === 'card' && !dialog) ? (
                                                    <div ref={totalCountGoodsRef} className="totalCountGoods mainButton"
                                                         onClick={() => {
                                                             handleClickOpenCountDialog();
                                                             handleBounceAnimation(totalCountGoodsRef);
                                                         }}
                                                         style={styleCounterTop}
                                                    >
                                                        {count}
                                                    </div>
                                                ) : (good !== null && dialog) ? null : (
                                                    <></>
                                                )
                                            }
                                            <FormDialog
                                                open={openDialogCount}
                                                setOpen={setOpenDialogCount}
                                                handleClickOpen={handleClickOpenCountDialog}
                                                handleClose={handleCloseCountDialog}
                                                textDialog={t('writeQuantityOfGoods')}
                                                labelDialog={t('quantityGoods')}
                                                inputState={countState}
                                                setInputState={setCountState}
                                                onSubmit={handleChangeCountItem}/>
                                        </div>
                                    </>

                                )
                            }
                        </>
                    )
                }
            </>
        )
            ;
    }
;

export default CounterGood;
